module.exports = __webpack_public_path__ + "assets/img/cancel_btn.c1b48d4a.png";